import { ChainId } from 'symbiosis-js-sdk'

import { useWallet, WalletStatus } from '~/lib/useWallet'
import Button, { ButtonProps } from '~/components/Button'
import { getChainById } from '~/lib/config'

type Props = {
	requiredChainId: ChainId
} & ButtonProps

export function SwitchNetworkButton({
	children,
	disabled,
	onClick,
	requiredChainId,
	...props
}: Props) {
	const wallet = useWallet()

	const chainConfig = getChainById(requiredChainId)

	const isWrongChain = !wallet.isCurrentChain(requiredChainId)

	let buttonText
	let buttonDisabled
	if (wallet.status === WalletStatus.DISCONNECTED) {
		buttonDisabled = true
		buttonText = 'Connect Wallet'
	} else if (isWrongChain) {
		buttonText = `Switch network to ${chainConfig.name}`
	} else {
		buttonDisabled = disabled
	}

	const onButtonClick = () => {
		if (isWrongChain) {
			wallet.setChain(requiredChainId)
			return
		}

		onClick()
	}

	return (
		<Button disabled={buttonDisabled} onClick={onButtonClick} {...props}>
			{buttonText || children}
		</Button>
	)
}
